import { Component, inject, Input } from '@angular/core';
import { CachedValuesService } from '@services/index';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementSharedInformationForm } from '../../../shared-agreement.model';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { map, Observable } from 'rxjs';
import { ListTypeItem } from 'app/types/list-type-item.type';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
    selector: 'app-new-agreement',
    templateUrl: './new-agreement.component.html',
    styleUrl: './new-agreement.component.scss'
})
export class NewAgreementComponent {
    @Input() public detailsForm: FormGroup<AgreementSharedInformationForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);
    private readonly translateService = inject(TranslateService);

    public readonly agreementTypes$: Observable<DropdownItem<number>[]> = this.cachedValuesService.agreementTypes$.pipe(
        map((data) =>
            data.map((item: ListTypeItem) => {
                return {
                    value: parseInt(item.name),
                    label: this.translateService.instant('FEATURES.AGREEMENTS.AGREEMENT_TYPES.' + item.name) as string
                } as DropdownItem<number>;
            })
        )
    );

    public get typeForm() {
        return this.detailsForm.controls;
    }
}
